var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #f7da9a;\n      }\n\n      .st2 {\n        fill: #ffebd0;\n      }\n\n      .st3 {\n        fill: #3b2a3b;\n      }\n\n      .st4 {\n        fill: #fff9ee;\n      }\n\n      .st5 {\n        fill: #c4c4c4;\n      }\n\n      .st6 {\n        fill: #fff;\n      }\n\n      .st7 {\n        clip-path: url(#project_management-clippath);\n      }\n\n      .st8 {\n        fill: #fdc728;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "project_management-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 29.1,
    y: 47,
    width: 133.8,
    height: 118
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_275",
    className: "st6",
    d: "M163.3,44.1c33.2,45.1,41.5,91.9,2.6,120.4-39.3,28.9-123.8,37.6-150.3.5C-13.8,123.9,1.1,48.1,37.7,19.7,76.8-10.7,130.6-.2,163.3,44.1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_185"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2751",
    "data-name": "Trac\\xE9_275",
    className: "st1",
    d: "M137,73.2c18,24.4,22.4,49.7,1.4,65.1-21.3,15.6-67,20.3-81.3.3-15.9-22.3-7.9-63.3,11.9-78.7,21.2-16.4,50.3-10.8,68,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_276",
    className: "st1",
    d: "M133,161.5c-2.4-3.6-2.5-7.7,1.7-10.5,4.3-2.9,12.5-4.3,14.4-1.3,2.1,3.3-.5,10.1-4.5,12.9-4.3,3-9.3,2.5-11.7-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_277",
    className: "st8",
    d: "M146.9,53.6l-27.9-6.3c-10.2-1.5-14.3,8.5-15.8,18.7,0,0-4.3,13.3,8.3,19.1-2.9,2.9-6.1,5.5-9.6,7.7-.5.3-.6.9-.4,1.3.4.8,1.3,1.2,2.1,1.1,1,0,2-.1,3.1-.3,2-.3,4.1-.7,6-1.3,4-1.3,7.8-2.9,11.5-4.8.4-.2.7-.4,1.1-.6l21.5,3.2c10.2,1.5,14.3-6.3,15.8-16.5,1.5-10.2-5.5-19.7-15.7-21.2,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_278",
    className: "st6",
    d: "M146.9,53.6l-27.9-6.1c-4.6-.7-9.1,1.6-11.2,5.7-2.3,3.9-3.3,8.4-3.9,12.9-2.1,7.1,1,15.2,8.1,18.1l1.2.6-.9.9c-2.9,3-6.2,5.6-9.7,7.9.3.6,1,.5,2,.4l2.4-.3c6.4-.9,12.4-3.5,18.1-6.5.3-.2.3-.2.6,0,6.4,1,12.7,2,19,3.1,6.7,1.7,12.6,0,15.4-6.8,6-12.7,1.8-27.1-13-29.9M146.9,53.6c15,2.6,19.3,17.4,13.7,30.2-2.8,7.2-9.1,9.4-16.3,7.8-6.4-.8-12.7-1.6-19.1-2.6h.6c-5.8,3.1-12.1,5.8-18.7,6.8-2,0-3.5.9-5.6-.2-1.3-.8-1.6-3-.1-3.8.7-.4,1.4-.9,2-1.3,2.6-1.9,5.1-3.9,7.4-6.2l.3,1.5c-3.6-1.7-6.9-4.6-8.3-8.4-1.3-3.7-1.5-7.8-.3-11.6,1.2-6.6,3.2-14.5,9.6-17.9,2.2-1,4.6-1.3,6.9-.8l27.8,6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_279",
    className: "st6",
    d: "M145.3,64.1h0c-.8-1.1-2.4-1.3-3.5-.5,0,0,0,0,0,0l-8.8,6.5c-1.1.8-2.7.6-3.5-.5l-2.8-3.8c-.8-1.1-2.4-1.4-3.5-.6s-1.4,2.4-.6,3.5c0,0,0,0,0,0l5.5,7.3c1,1.3,2.9,1.6,4.3.6l12.2-9.1c1.1-.8,1.3-2.4.5-3.5,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_280",
    className: "st8",
    d: "M85,161.3l-39.6,3.6c-5.1.5-9.6-3.3-10-8.3l-6.3-68.5c-.5-5.1,3.3-9.6,8.3-10l39.6-3.6c5.1-.5,9.6,3.3,10,8.3l6.3,68.5c.5,5.1-3.3,9.6-8.3,10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_281",
    className: "st4",
    d: "M84.4,155l-39.7,3.6c-2.3.2-4.3-1.5-4.5-3.8l-5.8-63.7c-.2-2.3,1.5-4.3,3.8-4.5l39.7-3.6c2.3-.2,4.3,1.5,4.5,3.8,0,0,0,0,0,0l5.8,63.7c.2,2.3-1.5,4.3-3.8,4.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_282",
    className: "st5",
    d: "M76.4,95.7l-34.7,3.2c-.8,0-1.5-.5-1.6-1.3,0-.8.5-1.5,1.3-1.6l34.7-3.2c.8,0,1.5.5,1.6,1.3,0,.8-.5,1.5-1.3,1.6h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_283",
    className: "st5",
    d: "M77,102.7l-19.6,1.8c-.8,0-1.5-.5-1.6-1.3s.5-1.5,1.3-1.6c0,0,0,0,0,0l19.6-1.8c.8,0,1.5.5,1.6,1.3,0,.8-.5,1.5-1.3,1.6,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_284",
    className: "st5",
    d: "M51,105.1l-8.7.8c-.8,0-1.5-.5-1.6-1.3,0-.8.5-1.5,1.3-1.6l8.7-.8c.8,0,1.5.5,1.6,1.3s-.5,1.5-1.3,1.6h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_285",
    className: "st5",
    d: "M65.8,110.5l-22.6,2.1c-.8,0-1.5-.5-1.6-1.3,0-.8.5-1.5,1.3-1.6l22.6-2.1c.8,0,1.5.5,1.6,1.3,0,.8-.5,1.5-1.3,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_286",
    className: "st5",
    d: "M79.7,126.9l-34.7,3.2c-.8,0-1.5-.5-1.6-1.3,0-.8.5-1.5,1.3-1.6l34.7-3.2c.8,0,1.5.5,1.6,1.3,0,.8-.5,1.5-1.3,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_287",
    className: "st5",
    d: "M80.3,133.9l-19.6,1.8c-.8,0-1.5-.5-1.6-1.3s.5-1.5,1.3-1.6h0l19.6-1.8c.8,0,1.5.5,1.6,1.3,0,.8-.5,1.5-1.3,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_288",
    className: "st5",
    d: "M78.2,148.7l-19.5,1.8c-.8,0-1.5-.5-1.6-1.3,0-.8.5-1.5,1.3-1.6l19.6-1.8c.8,0,1.5.5,1.6,1.3,0,.8-.5,1.5-1.3,1.6h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_289",
    className: "st5",
    d: "M54.3,136.3l-8.7.8c-.8,0-1.5-.5-1.6-1.3,0-.8.5-1.5,1.3-1.6,0,0,0,0,0,0l8.7-.8c.8,0,1.5.5,1.6,1.3,0,.8-.5,1.5-1.3,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_290",
    className: "st3",
    d: "M66.3,72.3l-4.6.4c0-.1,0-.3,0-.4,0-2.8-2.3-5-5.1-5-2.7,0-5,2.3-5,5,0,.5,0,.9.2,1.4l-3.9.4c-.8,0-1.5.7-1.5,1.5v4.2c0,.8.7,1.5,1.5,1.5h18.4c.8,0,1.5-.7,1.5-1.5h0v-6c0-.8-.7-1.5-1.5-1.5M54.2,72.3c0-1.3,1.1-2.4,2.4-2.4s2.4,1.1,2.4,2.4c0,.2,0,.5-.1.7l-4.4.4c-.2-.3-.3-.7-.3-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_291",
    className: "st3",
    d: "M118.9,106.8c.1.5.3,1,.6,1.5.4.8,1,1.6,1.7,2.2.7.7,1.5,1.3,2.5,1.5l-32,29.3c-1.4-1.5-2.8-3.1-4.2-4.6-.2-.2-.4-.4-.5-.6l32-29.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_292",
    className: "st3",
    d: "M85.5,140.1c.7.8,1.4,1.6,2.1,2.4l-3.2.8,1-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_293",
    className: "st2",
    d: "M86.9,136.2c.2.2.4.4.5.6,1.4,1.5,2.8,3.1,4.2,4.6h-.1c0,.1-3.8,1.1-3.8,1.1-.7-.8-1.4-1.6-2.2-2.4l1.2-3.8h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_294",
    className: "st2",
    d: "M124,106.9c.6.7,1,1.5,1.1,2.4,0,.8-.2,1.5-.7,2.1l-.7.7c-1-.2-1.8-.8-2.5-1.5-.7-.7-1.2-1.4-1.7-2.2-.3-.5-.5-1-.6-1.5l.7-.7c1.1-1,3.1-.7,4.4.7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectManagement);
export default __webpack_public_path__ + "static/media/project_management.ed6e3a19f9966d9c435fd1b55572d291.svg";
export { ForwardRef as ReactComponent };